import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { closeDialog, displayDialog } from "store/actions/utilActions";
//#endregion
//#region components
import useSupportTicketCreateDialog from "./useCreateDialog";
import { useNavigate } from "react-router-dom";
//#endregion
import { UrlHelper } from "utils/helpers";

const CreateView: React.FC = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const navigate = useNavigate();

  const { getDialog } = useSupportTicketCreateDialog();

  const dialogProps = getDialog();

  React.useEffect(() => {
    const onDialogClose = () => {
      dispatch(closeDialog(dialogProps.id));

      navigate(UrlHelper.formatPath("/Support"), {
        replace: true,
      });
    };

    dispatch(displayDialog(getDialog(onDialogClose, onDialogClose)));
  }, []);

  return <></>;
};

export default CreateView;
